import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import { useCallbackRef } from '@/js/libs/hooks/useCallbackRef';
import { Input } from '../Input';
import { Container, Counter, Prefix } from './styles';
const ALLOW_NEGATIVE_AND_POSITIVE_FLOAT = /^[-+]?\d*[.,]?\d*$/;
const ALLOW_NEGATIVE_AND_POSITIVE_PRICE = /^[-+]?\d*[.,]?\d{0,2}$/;
const ALLOW_NEGATIVE_AND_POSITIVE_PRICE_6D = /^[-+]?\d*[.,]?\d{0,6}$/;
const ALLOW_NEGATIVE_AND_POSITIVE_INT = /^[-+]?\d*$/;
const ALLOW_POSITIVE_INT = /^\d*$/;
const ALLOW_POSITIVE_FLOAT = /^\d*[.,]?\d*$/;
const ALLOW_POSITIVE_PRICE = /^\d*[.,]?\d{0,2}$/;
const ALLOW_POSITIVE_PERCENTAGE = /^\d*[.,]?\d{0,8}$/;
const REMOVE_HTML_TAGS = /(<([^>]+)>)/gi;
export const TextField = (props) => {
    const { component = Input, className = '', settings = {
        floatOnly: false,
        intOnly: false,
        regexp: undefined,
        callback: undefined,
        maxLength: undefined,
        prefix: null,
    }, input, meta: _meta, type = 'text', inputRef, dataTestId, onBlur, autoComplete = 'none', onChange, ...other } = props;
    // TODO: Fix this the next time the file is edited.
    // eslint-disable-next-line no-restricted-syntax
    const isChangeAllowed = React.useCallback((evt) => {
        if (settings.intOnly && !/^\d*$/.test(evt.target.value)) {
            return false;
        }
        if (settings.floatOnly && !/^\d*[.,]?\d*$/.test(evt.target.value)) {
            return false;
        }
        if (settings.regexp) {
            return new RegExp(settings.regexp).test(evt.target.value);
        }
        return true;
    }, [settings.floatOnly, settings.intOnly, settings.regexp]);
    const length = input.value ? input.value.length : 0;
    const handleChange = (event) => {
        const value = settings.callback?.(event?.target?.value) ?? event?.target?.value;
        event.target.value = value;
        if (!isChangeAllowed(event)) {
            return;
        }
        input.onChange(event);
        onChange?.(event);
    };
    const handleBlur = useCallbackRef((event) => {
        input.onBlur(event);
        onBlur?.(event);
    });
    return (_jsxs(Container, { $styled: { $prefix: settings.prefix, maxLength: settings.maxLength }, "data-testid": dataTestId, children: [settings.prefix && _jsx(Prefix, { $styled: { $textarea: false, rows: 1 }, children: settings.prefix }), React.createElement(component, {
                className,
                maxLength: settings.maxLength,
                ref: inputRef,
                type,
                ...input,
                onChange: handleChange,
                ...other,
                autoComplete,
                onBlur: handleBlur,
            }), settings.maxLength && (_jsx(Counter, { $styled: { $textarea: false, rows: 1 }, "data-testid": 'text-field-counter', children: `${length}/${settings.maxLength}` }))] }));
};
export { ALLOW_NEGATIVE_AND_POSITIVE_FLOAT, ALLOW_NEGATIVE_AND_POSITIVE_INT, ALLOW_NEGATIVE_AND_POSITIVE_PRICE, ALLOW_NEGATIVE_AND_POSITIVE_PRICE_6D, ALLOW_POSITIVE_FLOAT, ALLOW_POSITIVE_INT, ALLOW_POSITIVE_PRICE, ALLOW_POSITIVE_PERCENTAGE, REMOVE_HTML_TAGS, };
